import React from "react";
import { IAddUpdateCustomerPageState } from "../../../interfaces/Index";
import { IRiderManagementPageProps } from "../../../interfaces/riderManagement.interface";
import HeadingText from "../../common/HeadingText/HeadingText";
import AddUpdateRiderManagementPage from "./AddUpdateRiderManagementPage";
import RiderManagementList from "./RiderManagementList";

export default class RiderManagementPage extends React.Component<
  IRiderManagementPageProps,
  IAddUpdateCustomerPageState
> {
  constructor(props: IRiderManagementPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedRiderManagementUser: null,
      isRiderManagementUserAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
    };
  }

  renderAddUpdateRiderManagementPage = () => {
    const { isEdit, selectedRiderManagementUser, searchText } = this.state;
    const {
      createRiderUser,
      isRiderManagementUserAdded,
      getRiderUserDetails,
      isRiderListFetched,
      riderUserDetails,
      updateRiderUser,
      isRiderUpdated,
      isRiderDetailsFound,
      createRider,
      isRiderCreated,
      riderTypes,
      getRiderJobTypes,
      warehousesList,
      getWarehouses,
    } = this.props;
    return (
      <AddUpdateRiderManagementPage
        {...this.props}
        createRiderUser={createRiderUser}
        isRiderManagementUserAdded={isRiderManagementUserAdded}
        backButtonHandler={this.navigateBackToListingPage}
        dummyValidation={false}
        isEdit={isEdit}
        getRiderUserDetails={getRiderUserDetails}
        isRiderUserDetailsFetched={isRiderListFetched}
        selectedRiderManagementUser={selectedRiderManagementUser}
        riderUserDetails={riderUserDetails}
        updateRiderUser={updateRiderUser}
        isRiderUpdated={isRiderUpdated}
        searchText={searchText}
        isRiderDetailsFound={isRiderDetailsFound}
        createRider={createRider}
        getRiderJobTypes={getRiderJobTypes}
        riderTypes={riderTypes}
        isRiderCreated={isRiderCreated}
        warehousesList={warehousesList}
        getWarehouses={getWarehouses}
      />
    );
  };

  renderRiderManagementUserListing = () => {
    const {
      riders,
      getRiderManagementList,
      isRiderListFetched,
      isRiderUpdated,
      isRiderCreated,
      isRiderManagementUserAdded,
      error,
      pagination,
      isLoading,
      isError,
    } = this.props;
    const { searchText, currentListPosition, isRiderManagementUserAddUpdate } =
      this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Rider Management" isMainHeading={true} />
        </section>
        <RiderManagementList
          getRiderManagementList={getRiderManagementList}
          isRiderListFetched={isRiderListFetched}
          riders={riders}
          pagination={pagination}
          isLoading={isLoading}
          isError={isError}
          error={error}
          addUpdatePageHandler={this.toggleAddUpdateRiderManagementUserPage}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
          isRiderManagementUserAddUpdate={isRiderManagementUserAddUpdate}
          isRiderUpdated={isRiderUpdated}
          isRiderCreated={isRiderCreated}
          isRiderManagementUserAdded={isRiderManagementUserAdded}
        />
      </>
    );
  };

  toggleAddUpdateRiderManagementUserPage = (
    isEdit: boolean = false,
    selectedRiderManagementUser: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedRiderManagementUser: selectedRiderManagementUser,
      searchText: searchText,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isRiderManagementUserAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateRiderManagementPage()
          : this.renderRiderManagementUserListing()}
      </div>
    );
  }
}
